import { createTheme } from '@mui/material/styles'
import breakpoints from './breakpoints'
import palette from './palette'
import shadows from './shadows'
import typography from './typography'

export default createTheme({
  breakpoints,
  spacing: (factor: number) => `${factor}em`,
  shape: { borderRadius: 8 },
  palette,
  shadows,
  typography,
});

